import { render, staticRenderFns } from "./sellers.vue?vue&type=template&id=613b1063&scoped=true"
import script from "./sellers.vue?vue&type=script&lang=js"
export * from "./sellers.vue?vue&type=script&lang=js"
import style0 from "./sellers.vue?vue&type=style&index=0&id=613b1063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b1063",
  null
  
)

export default component.exports